import { Routes } from '@angular/router';
import { ForumPostsComponent } from './forum-posts/forum-posts.component';
import { ForumsComponent } from './forums/forums.component';

export const ForumRoutingModule: Routes = [
	{ path: 'forum', component: ForumsComponent },
	{ path: 'forum/:id', component: ForumPostsComponent },
];
